import { Injectable } from '@angular/core';
import { CVApiService } from '../../reusables/services/cv-api.service';
import { AchievedAchievementDTO } from './user-admin.model';

@Injectable({
  providedIn: 'root'
})
export class GamificationService {

    constructor(
        private apiService: CVApiService
    ) { }

    //gets badges by loginID
    async getAchievedAchievements(loginID: number): Promise<AchievedAchievementDTO[]> {
        let response = await this.apiService.get<AchievedAchievementDTO[]>("../api/v1/GetAchievedAchievements/" + loginID);
        if (response.status_code < 200 || response.status_code >= 300) {
            console.error("Failed to get badges by login.");
            throw response;
        }
        return response.data;
    };

    //gets recent badges by loginID
    async getRecentAchievedAchievements(loginID: number): Promise<AchievedAchievementDTO[]> {
        let response = await this.apiService.get<AchievedAchievementDTO[]>("../api/v1/GetRecentAchievedAchievements/" + loginID);
        if (response.status_code < 200 || response.status_code >= 300) {
            console.error("Failed to get recent badges by login.");
            throw response;
        }
        return response.data;
    };

    //gets orders by loginID
    async getPointStoreOrdersByLoginID(loginID: number): Promise<any> {
        let response = await this.apiService.get<any>("../api/v1/GetPointStoreOrdersByLoginID/" + loginID);
        if (response.status_code < 200 || response.status_code >= 300) {
            console.error("Failed to get orders by login.");
            throw response;
        }
        return response.data;
    };

    //gets min level xp by loginID
    async getNextLevelXP(loginID: number, profileID: number): Promise<number> {
        let response = await this.apiService.get<number>("../api/v1/GetNextLevelXP/" + loginID + "/" + profileID);
        if (response.status_code < 200 || response.status_code >= 300) {
            console.error("Failed to get min level xp by login.");
            throw response;
        }
        return response.data;
    };

    //add new spending history entry
    async addSpendingHistory(loginID: number, description, spendingChange): Promise<string> {
        let response = await this.apiService.get<string>("../api/v1/AddSpendingPointHistory/" + loginID + "/" + description + "/" + spendingChange);
        if (response.status_code < 200 || response.status_code >= 300) {
            console.error("Failed to add new entry to spending history.");
            throw response;
        }
        return response.data;
    };

    //add new gem history entry
    async addGemHistory(loginID, description, spendingChange): Promise<any> {
        let response = await this.apiService.get<any>("../api/v1/AddGemHistory/" + loginID + "/" + description + "/" + spendingChange);
        if (response.status_code < 200 || response.status_code >= 300) {
            console.error("Failed to add new entry to gem history.");
            throw response;
        }
        return response.data;
    };

    // get current admin user loginid
    async getCurrentAdminID(): Promise<any> {
        let response = await this.apiService.get<any>("../api/v1/GetCurrentAdminID");
        if (response.status_code < 200 || response.status_code >= 300) {
            console.error("Failed to get min level xp by login.");
            throw response;
        }
        return response.data;
    };
}
